import TripEnhancementsModal from './TripEnhancementsModal';

export default TripEnhancementsModal;
